import type { DownloadInfo } from './updater'
import { Updater } from './updater'

export class GenericUpdater extends Updater {
  async getVersion() {
    return { name: 'web', build: '' }
  }

  async checkUpdates() {
    return null
  }

  _getPlatform() {
    return 'bundle'
  }

  async _downloadUpdate(_info: DownloadInfo) {
    throw new Error('Not implemented')
  }

  async installUpdate() {
    throw new Error('Not implemented')
  }
}
